// Namespace for custom events (e.g. dv.init)
const EVENT_NS = 'dv';
// Error codes
const ERROR_GENERIC = 0;
const ERROR_INVALID_DATA = 1;
const ERROR_INCOMPLETE_DATA = 2;

class Chart {
  /** Attaches an event listener
   * @param {String} type - The event type to listen to (e.g. click)
   * @param {Function} listener - The handler function
   * @returns {Chart} - The Chart instance
   */
  on(type, listener) {
    this.el.addEventListener(type, listener);
    return this;
  }

  /** Detaches an event listener
   * @param {String} type - The event type to listen to (e.g. click)
   * @param {Function} listener - The handler function
   * @returns {Chart} - The Chart instance
   */
  off(type, listener) {
    this.el.removeEventListener(type, listener);
    return this;
  }

  /** Emits an event
   * @param {String} type - The event type to emit (e.g. click)
   * @param {Object} data - Data to add to the Event object
   * @returns {Chart} - The Chart instance
   */
  emit(type, data) {
    const e = document.createEvent('Event');
    e.dvData = data;
    e.initEvent(`${EVENT_NS}.${type}`, true, true);
    this.el.dispatchEvent(e);
    return this;
  }

  /** Emits a warning event
   * @param {String} message - The warning message
   * @param {Number} code - The error code
   * @param {Object} extras - Data to attach to the Event object
   */
  warn(message, code = ERROR_GENERIC, extras = null) {
    return this.emit('warn', { code, message, extras });
  }

  /** Emits an error event
   * @param {String} message - The error message
   * @param {Number} code - The error code
   * @param {Object} extras - Data to attach to the Event object
   */
  error(message, code = ERROR_GENERIC, extras = null) {
    return this.emit('error', { code, message, extras });
  }
}

// Expose some useful constants on Chart class
Object.assign(Chart, {
  ERROR_GENERIC,
  ERROR_INVALID_DATA,
  ERROR_INCOMPLETE_DATA,
});

export default Chart;
